import HTTP from "../../http";

const ORDERS_ENDPOINT = "/orders";
const CANCEL_ORDER_ENDPOINT = "/cancel/";

export async function cancelOrder(order) {
  return await HTTP.put(
    ORDERS_ENDPOINT + CANCEL_ORDER_ENDPOINT,
    {
      order
    },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
